/* global addthis */

export default {
    render(h) {
        const addThis = h(
            'div', {
                class: 'c-share addthis_inline_share_toolbox'
            }
        );

        const shareSpan = h(
            'span', {
                class: 'c-social__text'
            }, [this.shareText]
        );

        const container = h(
            'div', {
                class: 'c-social'
            }, [this.showText ? shareSpan : null, addThis]
        );

        return container;
    },
    props: {
        shareText: {
            type: String,
            default: 'Share:'
        },
        showText: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        // Force AddThis to refresh
        if(typeof addthis.layers.refresh !== 'undefined') {
            addthis.layers.refresh();
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-share.js